<template>
  <div class="coupon-general-wrap">
    <el-card class="coupon-general-body">
      <!-- 顶部按钮区域 -->
      <el-row class="common-con-btns mb10">
        <el-button size="small" type="primary" @click="addCoupon">添加</el-button>
      </el-row>
      <!-- 表格区域 -->
      <!-- 筛选区域 -->
      <el-form :inline="true" :model="searchForm" ref="searchForm" size="mini">
        <el-form-item label="筛选"></el-form-item>
        <el-form-item>
          <el-input
            class="select-input"
            placeholder="店铺id"
            size="mini"
            v-model="searchForm.shop_id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.status">
            <el-option value label="全部"></el-option>
            <el-option :value="1" label="已上架"></el-option>
            <el-option :value="2" label="待上架"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSearch" size="mini" type="primary">筛选</el-button>
          <el-button @click="onReset" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        class="page-wrap"
        :data="dataList"
        ref="listTable"
        :row-class-name="tableRowClassName"
        header-row-class-name="table-black-header"
        style="width: 100%"
      >
        <el-table-column label="优惠券名称" prop="name"></el-table-column>
        <el-table-column label="优惠券面额">
          <template slot-scope="scope">￥{{ scope.row.denomination }}</template>
        </el-table-column>
        <el-table-column label="兑换所需积分" prop="score"></el-table-column>
        <el-table-column label="有效期">
          <template slot-scope="scope">
            <span v-if="scope.row.has_validity_period == 1">{{ scope.row.valid_day }}天</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="兑换说明" prop="description"></el-table-column>
        <el-table-column label="排序" prop="sort"></el-table-column>
        <el-table-column label="优惠券类型" min-width="100">
          <template slot-scope="scope">
            <span>{{scope.row.coupon_type==1?'通用优惠券':'门店优惠券'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">已上架</span>
            <span v-if="scope.row.status == 2">待上架</span>
            <span v-if="scope.row.status == 3">删除</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.coupon_type==2"
              type="text"
              size="mini"
              @click="seeShops(scope.row)"
            >查看店铺</el-button>
            <el-button type="text" size="mini" @click="toEditCoupon(scope.row.id)">编辑</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="scope.row.status == 2"
              @click="enableCoupon(scope.row.id)"
            >上架</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="scope.row.status == 1"
              @click="disableCoupon(scope.row.id)"
            >下架</el-button>
            <el-button type="text" size="mini" @click="delCoupon(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="page.total"
          :page-size="page.pageSize"
          @current-change="currentPageChange"
          :current-page="page.currentPage"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { couponApi } from "@/api/coupon";
export default {
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 50,
        total: 1
      },
      dataList: [],
      searchForm: {
        shop_id: "",
        status: ""
      },
      isedit: false,
      coupon_id: ""
    };
  },
  created() {
    if (this.$route.query.str) {
      this.isedit = true;
    }
    this.initData();
  },
  methods: {
    /**
     * 初始化
     */
    initData() {
      this.getList();
    },
    /**
     * 编辑某一列的状态
     */
    tableRowClassName({ row, rowIndex }) {
      let finded = false;
      var index = null;
      if (!finded) {
        for (var i = 0; i < this.dataList.length; i++) {
          if (this.$route.query.str) {
            if (
              this.dataList[i].id ==
                parseInt(this.$route.query.str.split("_")[0]) &&
              this.page.currentPage ==
                parseInt(this.$route.query.str.split("_")[1])
            ) {
              index = i;
              finded = true;
            }
          } else {
            index = null;
          }
        }
      }
      if (rowIndex === index) {
        return "success-row";
      } else {
        return "";
      }
    },
    /**
     * 获取优惠券列表
     */
    getList() {
      if (this.$route.query.str && this.isedit) {
        this.$set(
          this.page,
          "currentPage",
          parseInt(this.$route.query.str.split("_")[1])
        );
      }
      const pam = {
        page: this.page.currentPage,
        per_page: this.page.pageSize,
        shop_id: this.searchForm.shop_id,
        status: this.searchForm.status
      };

      this.$EpetJs.Common.get(couponApi.getGeneralCouponUrl, pam, {
        needLoading: true
      }).then(res => {
        this.dataList = res.data.data;
        if (res.data.meta && res.data.meta.pagination) {
          this.page.total = res.data.meta.pagination.total;
        }
      });
      // }
    },
    /**
     * 筛选
     */
    onSearch() {
      this.isedit = false;
      this.getList();
    },
    /**
     * 重置
     */
    onReset() {
      this.isedit = false;
      this.searchForm.shop_id = "";
      this.searchForm.status = "";
      this.page.currentPage = 1;
      this.getList();
    },
    /**
     * 筛选
     */
    onSearch() {
      this.getList();
    },
    /**
     * 重置
     */
    onReset() {
      this.searchForm.shop_id = "";
      this.searchForm.status = "";
      this.page.currentPage = 1;
      this.getList();
    },
    /**
     * 启用优惠券
     * @param id
     */
    enableCoupon(id) {
      this.$EpetJs.Common.patch(couponApi.enableCouponUrl + "/" + id).then(
        res => {
          this.$message.success("上架成功！");
          this.getList();
        }
      );
    },
    /**
     * 停用优惠券
     * @param id
     */
    disableCoupon(id) {
      this.$EpetJs.Common.patch(couponApi.disableCouponUrl + "/" + id).then(
        res => {
          this.$message.success("下架成功！");
          this.getList();
        }
      );
    },
    /**
     * 删除优惠券
     * @param id
     */
    delCoupon(id) {
      this.$EpetJs.Common.confirm("是否确定删除该优惠券", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$EpetJs.Common.delete(
            couponApi.deGeneralCouponUrl + "/" + id
          ).then(res => {
            if (res) {
              this.$message.success("删除成功！");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    /**
     * 跳转添加优惠券
     */
    addCoupon() {
      this.$router.push("/coupon/add");
    },
    /**
     * 跳转编辑优惠券
     */
    toEditCoupon(id) {
      let pam = id + "_" + this.page.currentPage;
      this.$router.push("/coupon/edit/" + pam);
    },
    /**
     * 当前页改变
     * @param val
     */
    currentPageChange(val) {
      this.isedit = false;
      this.page.currentPage = val;
      this.getList();
    },
    /**
     * 查看店铺弹窗
     * @param row
     */
    seeShops(row) {
      this.coupon_id = row.id;
      //跳转店铺页面
      this.$router.push({
        path: "/coupon/shop_list",
        query: {
          coupon_id: row.id
        }
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/css/common.css";
</style>
<style lang="less" scoped>
.coupon-general-wrap {
  .coupon-general-body {
    min-height: calc(100vh - 60px);
    .edit-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
</style>